// keystoreService.js — pasa por manageKeystore.js (requiere sesión) en vez de
// leer/escribir Firestore directo. Sin onSnapshot: las Netlify Functions no
// dan tiempo real, así que la vista recarga tras cada mutación.
import { authService } from './authService';

async function request(url, opts = {}) {
  const resp = await fetch(url, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...authService.authHeader(), ...(opts.headers || {}) },
  });
  const data = await resp.json();
  if (!data.success) throw new Error(data.error || 'Error de red');
  return data;
}

export const fetchEntries = async () => {
  const data = await request('/.netlify/functions/manageKeystore');
  return data.entries;
};

export const createEntry = async (data) => {
  const result = await request('/.netlify/functions/manageKeystore', {
    method: 'POST', body: JSON.stringify(data),
  });
  return { id: result.id, ...data };
};

export const updateEntry = async (id, data) => {
  await request('/.netlify/functions/manageKeystore', {
    method: 'POST', body: JSON.stringify({ id, ...data }),
  });
};

export const deleteEntry = async (id) => {
  await request(`/.netlify/functions/manageKeystore?id=${id}`, { method: 'DELETE' });
};
